import React from 'react';
import { Outlet } from 'react-router-dom';
import InvestmentNav from '../components/InvestmentNav';

function Investments() {
  return (
    <div>
      <InvestmentNav />
      <Outlet />
    </div>
  );
}

export default Investments;
